import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/dashboard-app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/styles/global.css");
